export class TotalSubCategoryActBudRevenue{
    categoryName:string;
    subCategoryName:string;
    tdyActRevenue:string;
    tdyBudget:string;
    mtdActual: string;
}